class Modify_User_Group_Status {
    static path = 'group-actions/modify-group-member-status';

    constructor(mutator){
        this.title = 'Make/remove a group leader';
        this.addInput("Determining Condition", "boolean");
        this.addInput("User", "user,user_id");
        this.addInput("Group", "group,group_id");
        this.bgcolor = '#dea059';
        this.desc = 'Make a group member a group lead, or remove that status.';

        this.properties = {operation: ''}
        this.addWidget("combo", "", '', {property: "operation", values: ['Promote to group leader', 'Remove from group leaders']});
    }

    getTitle() {
        if(this.properties.operation) return this.properties.operation;
        return this.title;
    }
}

module.exports = Modify_User_Group_Status
